import React, { useEffect, useRef, useState } from 'react';
import config from '../../config';
import { liffGetProfile } from '../../services/promotion/auth.service';
import axios from 'axios';

const liff = window.liff

export const Privilege = ({ redirect }) => {
  const ref = useRef();
  const [aboId, setAboId] = useState(null);

  useEffect(() => {
    const initLiffAndFetch = async () => {
        await liff.init({
          liffId: process.env.REACT_APP_LIFF_CLIENT_ID, withLoginOnExternalBrowser: false,
        });
        if (!liff.isLoggedIn()) {
          liff.login({ redirectUri: window.location.href });
          return;
        }

        let profile = await liffGetProfile();
        profile.token = await liff.getAccessToken();

        axios.post(`${process.env.REACT_APP_API_URL}/auth/token`, profile)
          .then(async (res) => {
            axios({
              method: "get",
              url: `${process.env.REACT_APP_API_URL}/customers`,
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${res.data.token}`
              },
            })
              .then((res) => {
                if (res?.data?.amwayNumber ) {
                    setAboId(parseInt(res?.data?.amwayNumber, 10));
                  } 
              })
              .catch((err) => {
                console.log("Customer fetch failed", err);
              });
          })
          .catch(async (err) => {
            console.log("Token fetch failed", err);            
          });
      };

    initLiffAndFetch();
  }, [redirect]);
  
  const payload = {
    abo_id : aboId
  }
  const state =  btoa(JSON.stringify(payload));
  useEffect(() => {
    if (aboId && ref.current) {
    ref.current.submit();
    }
  }, [aboId]);
  return (
    <div>
      Loading...
      <form
        ref={ref}
        id="appForm"
        method="post"
        action={`${config.GLUU_IDP_URL}?response_mode=form_post`}
      >
        <input
          type="hidden"
          name="scope"
          value={`openid profile`}
        />
        <input
          type="hidden"
          name="acr_values"
          value={`social_lbc`}
        />
        <input
          type="hidden"
          name="response_type"
          value="id_token"
        />
        <input
          type="hidden"
          name="state"
          value={`${state}`}
        />
        <input
          type="hidden"
          name="nonce"
          value={`${config.GLUU_IDP_NONCE}`}
        />
        <input
          type="hidden"
          name="client_id"
          id="client_id"
          value={`${config.PRIVILEGE_CLIENTID}`}
        />
        <input
          type="hidden"
          name="redirect_uri"
          id="redirect_uri"
          value={`${config.PRIVILEGE_REDIRECT_URI}`}
        />
        <input style={{ display: 'none' }} type="submit" value="submit" />
      </form>
    </div>
  );
};

export default Privilege;